// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import EmailLine from "@store/Library/Components/Toolkit/Icons/Email/EmailLine";
import parse from "html-react-parser";
import React, { FC } from "react";
import { css } from "styled-components";

type SignUpEmailSentFieldValue = string;

const enum fields {
    messageContent = "messageContent",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.messageContent]: SignUpEmailSentFieldValue;
    };
}

export interface SignUpEmailSentStyles {
    container?: InjectableCss;
    contentWrapper?: InjectableCss;
    iconWrapper?: InjectableCss;
    richTextWrapper?: InjectableCss;
}

export const signUpEmailSentStyles: SignUpEmailSentStyles = {
    container: {
        css: css`
            background: #f5f5f5;
            border-radius: ${x => x.theme.design.common.contentRadius};
            padding: 3rem 2rem;
            display: flex;
            justify-content: center;
        `,
    },
    contentWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1.5rem;
            max-width: 40rem;
            text-align: center;
        `,
    },
    iconWrapper: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            width: 5rem;
            height: 5rem;
            border-radius: 50%;
            background: ${getColor("common.background")};
            color: ${getColor("primary")};

            svg {
                width: 3rem;
                height: 3rem;
            }
        `,
    },
    richTextWrapper: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.base};
            line-height: 1.6;

            > *:first-child {
                margin-top: 0;
            }

            > *:last-child {
                margin-bottom: 0;
            }
        `,
    },
};

const StyledContainer = getStyledWrapper("section");
const StyledContent = getStyledWrapper("div");
const StyledIconWrapper = getStyledWrapper("div");
const StyledRichText = getStyledWrapper("div");

const styles = signUpEmailSentStyles;

const SignUpEmailSent: FC<OwnProps> = ({ fields: { messageContent } }) => {
    return (
        <StyledContainer {...styles.container} data-test-selector="signUpEmailSent_container">
            <StyledContent {...styles.contentWrapper}>
                <StyledIconWrapper {...styles.iconWrapper} aria-hidden="true">
                    <EmailLine />
                </StyledIconWrapper>
                <StyledRichText {...styles.richTextWrapper}>
                    {parse(messageContent || "", parserOptions)}
                </StyledRichText>
            </StyledContent>
        </StyledContainer>
    );
};

const widgetModule: WidgetModule = {
    component: SignUpEmailSent,
    definition: {
        allowedContexts: ["SignInPage", "SignInOverlay"],
        displayName: "Sign Up Email Sent",
        group: "Sign In",
        icon: "Mail",
        fieldDefinitions: [
            {
                name: fields.messageContent,
                displayName: "Message Content",
                editorTemplate: "RichTextField",
                defaultValue:
                    "<p>Check your inbox for the activation email we just sent. Follow the link to finish setting up your account.</p>",
                fieldType: "Translatable",
                extendedConfig: { height: 220 },
                expandedToolbarButtons: {
                    moreMisc: {},
                    code: {},
                },
            },
        ],
    },
};

export default widgetModule;
